var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "columns" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "b-field",
          [
            _c("b-switch", {
              staticClass: "mr-2",
              attrs: { "data-cy": `switch-${_vm.id}`, size: "is-small" },
              nativeOn: {
                input: function ($event) {
                  return _vm.onSwitchChange($event.target.checked)
                },
              },
              model: {
                value: _vm.componentVisibility,
                callback: function ($$v) {
                  _vm.componentVisibility = $$v
                },
                expression: "componentVisibility",
              },
            }),
            _c("span", { staticClass: "is-inline-block" }, [
              _vm._v(" " + _vm._s(_vm.label)),
              _c("br"),
              _c("small", [_vm._v(_vm._s(_vm.labelDescription))]),
            ]),
          ],
          1
        ),
        _c(
          "b-collapse",
          { attrs: { open: _vm.componentVisibility } },
          _vm._l(_vm.value, function (val, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "inner is-vcentered",
                attrs: { "data-cy": `base-input-${_vm.id}` },
              },
              [
                _vm._l(_vm.template, function (field, f) {
                  return _c("BaseInput", {
                    key: f,
                    staticClass: "inner-col",
                    attrs: { id: `bi-${index}-${f}`, field: field },
                    on: {
                      input: (event) =>
                        _vm.updateInputs(index, event, field.name, field.type),
                    },
                    model: {
                      value: val[field.name],
                      callback: function ($$v) {
                        _vm.$set(val, field.name, $$v)
                      },
                      expression: "val[field.name]",
                    },
                  })
                }),
                _vm.isArray
                  ? _c(
                      "div",
                      { staticClass: "inner-col" },
                      [
                        index === 0
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "is-text",
                                  size: "is-small",
                                  rounded: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.addInputs()
                                  },
                                },
                              },
                              [_c("b-icon", { attrs: { icon: "plus" } })],
                              1
                            )
                          : _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "is-text",
                                  size: "is-small",
                                  rounded: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeInputs(index)
                                  },
                                },
                              },
                              [_c("b-icon", { attrs: { icon: "times" } })],
                              1
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }